import React, { Component } from 'react'
import { ResponsiveBar } from '@nivo/bar'
import './ChartBar.scss'
import { CScolours } from '../../../config'

class ChartBar extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    };

    render() {

      console.log(this.props)

        return (
            <div className='chart-bar' style={{height: this.props.height}}>
              <ResponsiveBar
                 data={this.props.data}
                 keys={this.props.keys}
                 indexBy="tabs"
                 margin={{
                     "top": 10,
                     "right": 100,
                     "bottom": 25,
                     "left": 60
                 }}
                 padding={0.3}
                 groupMode="grouped"
                 colors={this.props.colors ? this.props.colors : CScolours}
                 colorBy="id"
                 enableGridY={true}
                 enableGridX={true}
                 labelTextColor='#fff'
                 axisBottom={{
                     "orient": "bottom",
                     "tickSize": 5,
                     "tickPadding": 5,
                     "tickRotation": 0
                 }}
                 axisLeft={{ format: v => `£${v}` }}
                 axisLeft={{
                     "orient": "left",
                     "tickSize": 5,
                     "tickPadding": 5,
                     "tickRotation": 0,
                     "tickValues": [25, 50, 100]
                 }}
                 enableLabel={false}
                 maxValue={this.props.maxValue}
                 axisLeft={{ format: v => `£${v}` }}
                 animate={true}
                 motionStiffness={90}
                 motionDamping={15}
                 legends={[
                     {
                         "dataFrom": "keys",
                         "anchor": "right",
                         "direction": "column",
                         "translateX": 120,
                         "itemWidth": 100,
                         "itemHeight": 20,
                         "itemsSpacing": 2,
                         "symbolSize": 20
                     }
                 ]}

                 theme={{
                    "tooltip": {
                        "container": {
                            "fontSize": "13px"
                        }
                    },
                    "ticks": {
                        "textColor": "#999"
                    }
                }}




             />
            </div>
        )
    }
}

export default ChartBar;



// WEBPACK FOOTER //
// ./src/views/components/ChartBar/index.js